







































































































































import {getLogList} from '@/api/operatelogs'
import router from '@/router';
export default  {
  //模型数据
  data() {
    return {
      userTypeMap: {
        0: '管理员',
        1: '咨询师',
        2: '学生'
      },
      page: 1, //页码
      pageSize: 10, //每页记录数
      total: 0, //总记录数
      records: [], //当前页要展示的数据集合
      // -------------------------
      // 查询参数
      name: '', //员工姓名，对应上面的输入框
      selectedValue: '', // 下拉框绑定的值
      options: [ // 下拉框的选项数据
        { value: '', label: '全部' },
        { value: '0', label: '管理员' },
        { value: '1', label: '咨询师' },
        { value: '2', label: '学生' },

      ],
      valueTime: [], // 起止时间
      opContent: '', // 操作类型
      // opType: ''

    }
  },
  created() {
    this.pageQuery()
  },
  methods: {

    init(){
      this.page = 1
    },
    // 下拉框赋值
    handleChange(value){
      this.selectedValue = value;
      this.page = 1
      // alert(this.selectedValue)
    },
    //分页查询
    pageQuery() {
      //准备请求参数
      const params = {

        page:this.page,
        pageSize:this.pageSize,
        name:this.name,
        userType: this.selectedValue,
        opContent: this.opContent,
        startTime: this.valueTime[0],
        endTime: this.valueTime[1]

      }

      //发送Ajax请求，访问后端服务，获取分页数据
      getLogList(params).then(res => {
        if(res.data.code === 1) {
          this.total = res.data.data.total
          this.records = res.data.data.records
        }
      }).catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
    },
    //pageSize发生变化时触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    //page发生变化时触发
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },
    //启用禁用员工账号
    // handleStartOrStop(row) {
    //   if(row.username === 'admin'){
    //     this.$message.error('admin为系统的管理员账号，不能更改账号状态！')
    //     return
    //   }

    //   //alert(`id=${row.id} status=${row.status}`)

    // //弹出确认提示框
    // this.$confirm('确认要修改当前员工账号的状态吗?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       const p = {
    //         id: row.id,
    //         status: !row.status ? 1 : 0
    //       }

    //       enableOrDisableEmployee(p).then(res => {
    //         if(res.data.code === 1) {
    //           this.$message.success('员工的账号状态修改成功！')
    //           this.pageQuery()
    //         }
    //       })
    //     })
    // },
    // //跳转到新增员工页面（组件）
    // handleAddEmp(){
    //   //路由跳转，跳转到新增员工组件
    //   this.$router.push('/employee/add')
    // },
    // //跳转到修改员工页面（组件）
    // handleUpdateEmp(row) {
    //   if(row.username === 'admin'){
    //     this.$message.error('admin为系统的管理员账号，不能修改！')
    //     return
    //   }

    //   //跳转到修改页面，通过地址栏传递参数
    //   this.$router.push({
    //     path: '/employee/add',
    //     query: {id: row.id}
    //   })
    // }
  }
}
